"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setDef = exports.defTight = exports.defNormal = exports.createDef = exports.create = void 0;
function create() {
    var obj = {
        target: 0,
        position: 0,
        velocity: 0,
        acceleration: 0,
        stiffness: 70,
        friction: 3,
        // threshold: 0.04,
    };
    return obj;
}
exports.create = create;
function createDef() {
    return {
        stiffness: 70,
        friction: 3,
        // threshold: 0.04,
    };
}
exports.createDef = createDef;
function defNormal() {
    return {
        stiffness: 70,
        friction: 3,
        // threshold: 0.04,
    };
}
exports.defNormal = defNormal;
function defTight() {
    return {
        stiffness: 70,
        friction: 15,
        // threshold: 0.04,
    };
}
exports.defTight = defTight;
function setDef(obj, def) {
    obj.friction = def.friction;
    obj.stiffness = def.stiffness;
    // obj.threshold = def.threshold
}
exports.setDef = setDef;
function update(obj, dt) {
    var eps = 0.01;
    var delta = obj.target - obj.position;
    if (Math.abs(delta) < eps &&
        Math.abs(obj.velocity) < eps &&
        Math.abs(obj.acceleration) < 0) {
        obj.position = obj.target;
        obj.acceleration = 0;
        obj.velocity = 0;
        return;
    }
    obj.acceleration = obj.stiffness * delta - obj.friction * obj.velocity;
    obj.velocity += obj.acceleration * dt;
    obj.position += obj.velocity * dt;
}
exports.update = update;
